import {customAxiosBE} from "../config";
import {customForSaleparsePaginationParams} from "../../utils/other";

// Drugi kanali prodaje (FIDKP). Server sam sužava na prijavljenog prevoznika —
// carrierId se ne šalje.

export async function getSalesChannelsAPI() {
    return customAxiosBE.get(`/salesChannel`);
}

export async function fidkpSummaryAPI(data) {
    return customAxiosBE.post(`/salesChannel/fidkp/summary`, data);
}

// Ručno slanje izveštaja: adresa ide po pozivu i ne pamti se na serveru.
export async function sendFidkpReportAPI(data) {
    return customAxiosBE.post(`/salesChannel/fidkp/send`, data);
}

// Istorija mesečnih slanja. Opseg određuje server po prijavljenom nalogu:
// prevoznik dobija svoje redove, nalog kanala sve prevoznike tog kanala.
export async function fidkpHistoryAPI() {
    return customAxiosBE.get(`/salesChannel/fidkp/history`);
}

export async function fidkpTicketsAPI(data, params) {
    const parsedParams = customForSaleparsePaginationParams(params);
    return customAxiosBE.post(`/salesChannel/fidkp/tickets?${parsedParams}`, data);
}

const MAX_PAGE_SIZE = 2000;

// Sve strane redom (po 2000) — izveštaj mora da obuhvati ceo period.
export async function fetchAllFidkpTicketsAPI(data) {
    const all = [];
    for (let page = 0; ; page += 1) {
        // eslint-disable-next-line no-await-in-loop
        const {data: pageData} = await fidkpTicketsAPI(data, {
            page,
            rowsPerPage: MAX_PAGE_SIZE,
            order: "desc",
            orderBy: "salesTime",
        });
        const content = pageData?.content || [];
        all.push(...content);
        const total = pageData?.totalElements ?? all.length;
        if (content.length < MAX_PAGE_SIZE || all.length >= total) break;
    }
    return all;
}
